import React from "react";
import { Form, Message, Popup, Icon, Button } from "semantic-ui-react";

function Jackpot(props) {
  const { values, valid, orderLimitEnabled } = props;

  return (
    <Form size="large" error={valid.errorCount > 0}>
      <Message
        error
        content={Object.keys(valid.errors.all()).map((item, key) => {
          return (
            <span key={key}>
              {valid.errors.first(item)}
              <br />
            </span>
          );
        })}
      />
      <Form.Select
        name="event.jackpot_id"
        placeholder="Jackpot Screen"
        label="Jackpot Screen"
        options={props.screens}
        value={values.jackpot_id}
        onChange={props.handleChange}
        autoComplete="off"
      />
      {values.game_id !== 2 && values.game_id !== 4 && <Form.Input
        name="event.jackpot_start"
        label={() => (
          <Popup
            trigger={
              <label>
                <Icon name="help circle" color="blue" fitted /> Guaranteed Jackpot Amount
              </label>
            }
            content="Use this option to set a guaranteed jackpot amount. This amount will remain displayed as the jackpot until your sales have surpassed it. Whenever setting a guaranteed jackpot amount it is recommended that you be conservative as this is a tool used to motivate ticket sales and should not exceed your anticipated jackpot total."
            inverted
            wide
          />
        )}
        value={values.jackpot_start}
        onChange={props.handleChange}
      />}
      <Form.Group inline>
        <label>Round Jackpot</label>
        <Form.Radio
          toggle
          name="event.normalize_jackpot"
          className="radioToggleBtn"
          label={
            values.normalize_jackpot == 1
              ? "The Jackpot displays will round to the nearest 0 or 5."
              : "The Jackpot displays will round to the nearest dollar"
          }
          value="1"
          checked={values.normalize_jackpot == 1}
          onChange={props.handleChange}
        />
      </Form.Group>
      <Form.Group inline>
        <label>Round Prize</label>
        <Form.Radio
          toggle
          name="event.normalize_jackpot_prize"
          className="radioToggleBtn"
          label={
            values.normalize_jackpot_prize == 1
              ? "The Prize displays will round to the nearest 0 or 5."
              : "The Prize displays will round to the nearest dollar"
          }
          value="1"
          checked={values.normalize_jackpot_prize == 1}
          onChange={props.handleChange}
        />
      </Form.Group>
      {values.game_id !== 2 && values.game_id !== 4 && <Form.Input
        label={() => (
          <Popup
            trigger={
              <label>
                <Icon name="help circle" color="blue" fitted /> Sweeten Pot (Initial Contribution)
              </label>
            }
            content="To rapidly promote ticket sales, you may contribute $ to the jackpot. All sales that take place will add to this jackpot amount. Note: Your organization will be responsible for any contributions added using this feature."
            inverted
            wide
          />
        )}
        name="event.sweetenpot"
        value={values.sweetenpot}
        onChange={props.handleChange}
        disabled={+values.id > 0}
      />}
      <Form.Input
        label={() => (
          <Popup
            trigger={
              <label>
                <Icon name="help circle" color="blue" fitted /> Prize Limit
              </label>
            }
            content="This option will allow you to set a maximum prize limit. Once reached, sales are still permitted, but the jackpot amount will stop increasing.."
            inverted
            wide
          />
        )}
        name="event.prizelimit"
        value={values.prizelimit}
        onChange={props.handleChange}
        disabled={values.game_id === 2}
      />
      {orderLimitEnabled && <Form.Input
        label={() => (
          <Popup
            trigger={
              <label>
                <Icon name="help circle" color="blue" fitted /> Order Limit
              </label>
            }
            content="This option will allow you to set a maximum order limit. Once reached, no new sales will be allowed. Note that entering a value here will effectively disable the offline mode for devices since they will have to connect to the server before every sale to verify the jackpot amount."
            inverted
            wide
          />
        )}
        name="event.orderlimit"
        value={values.orderlimit}
        onChange={props.handleChange}
      />}

      <Button
        type="button"
        primary
        size="large"
        content="Save And Continue"
        onClick={() => props.handleStep("expenses")}
        floated="right"
      />
      <Button
        type="button"
        size="large"
        content="Go Back"
        onClick={() => props.handleStep("pricing")}
        floated="right"
      />

    </Form>
  );
}

export default Jackpot;
